import React from "react";

import logo from "../../assets/images/logo.svg";
import yearOfAiLogo from "../../assets/images/year-of-ai-2026.png";

import PageFeedback from "../Common/PageFeedback/PageFeedback";

import "./Footer.css";

const LAST_UPDATED =
  "29/07/2026 - 4:13 م";

const Footer = () => {
  const currentYear =
    new Date().getFullYear();

  return (
    <>
      <div className="dga-last-updated">
        <div className="dga-last-updated__inner">
          <p className="dga-last-updated__text">
            تاريخ آخر تعديل:{" "}
            {LAST_UPDATED} بتوقيت
            السعودية
          </p>
        </div>
      </div>

      {/* Feedback appears below update date */}
      <PageFeedback />

      <footer className="dga-footer">
        <div className="dga-footer__inner">
          <div className="dga-footer__information">
            <p className="dga-footer__copyright">
              جميع الحقوق محفوظة
              لصندوق تنمية الموارد
              البشرية ©{" "}
              {currentYear}
            </p>

            <nav
              className="dga-footer__links"
              aria-label="روابط تذييل الصفحة"
            >
              <a href="https://hrdf.org.sa">
                الشروط والأحكام
              </a>

              <a href="https://hrdf.org.sa">
                سياسة الخصوصية
              </a>
            </nav>
          </div>

          <div className="dga-footer__branding">
            <img
              src={logo}
              alt="صندوق تنمية الموارد البشرية"
              className="dga-footer__logo"
            />

            <span
              className="dga-footer__logo-separator"
              aria-hidden="true"
            />

            <img
              src={yearOfAiLogo}
              alt="عام الذكاء الاصطناعي 2026"
              className="dga-footer__campaign-logo"
            />
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;